reportFilterMixin = require '../../mixins/report-filter'

module.exports = App.CheckboxReportFilterComponent = Ember.Component.extend reportFilterMixin
